import React, { useState } from 'react'

const AlphabeticalFilter = (props) => {
    const [rangeFilter, setRangFilter] = useState("A-Z");

    return (
        <div className="filter_container">
            <div
                style={
                    rangeFilter === "A-B"
                        ? {
                            borderColor: "red",
                        }
                        : {}
                }
                className="filter_item"
                onClick={() => { props.onFilter("A-B"); setRangFilter("A-B") }}
            >
                A-B
            </div>
            <div
                style={
                    rangeFilter === "C-E"
                        ? {
                            borderColor: "red",
                        }
                        : {}
                }
                className="filter_item"
                onClick={() => { props.onFilter("C-E"); setRangFilter("C-E") }}
            >
                C-E
            </div>
            <div
                style={
                    rangeFilter === "F-H"
                        ? {
                            borderColor: "red",
                        }
                        : {}
                }
                className="filter_item"
                onClick={() => { props.onFilter("F-H"); setRangFilter("F-H") }}
            >
                F-H
            </div>
            <div
                style={
                    rangeFilter === "I-M"
                        ? {
                            borderColor: "red",
                        }
                        : {}
                }
                className="filter_item"
                onClick={() => { props.onFilter("I-M"); setRangFilter("I-M") }}
            >
                I-M
            </div>
            <div
                style={
                    rangeFilter === "N-R"
                        ? {
                            borderColor: "red",
                        }
                        : {}
                }
                className="filter_item"
                onClick={() => { props.onFilter("N-R"); setRangFilter("N-R") }}
            >
                N-R
            </div>
            <div
                style={
                    rangeFilter === "S-Z"
                        ? {
                            borderColor: "red",
                        }
                        : {}
                }
                className="filter_item"
                onClick={() => { props.onFilter("S-Z"); setRangFilter("S-Z") }}
            >
                S-Z
            </div>
        </div>
    )
}

export default AlphabeticalFilter;